import { UseMutationOptions, useMutation } from '@tanstack/react-query'
import { getSignedUrl } from '~/mutations/file-upload/get-signed-url'

export const useGetSignedUrl = (
  options: UseMutationOptions<any, unknown, { key: string; name?: string; type?: string }, unknown>,
) => {
  return useMutation({ mutationFn: getSignedUrl, ...options })
}
